import ConferDetaiBanner from "./views/ConferDetailBanner";
import ConferDetailHead from "./views/ConferDetailHead";
import RegisterNew from "../NewEvent/views/RegisterNew";

export default function ConferDetail() {
  return (
    <div className="w-full pt-[71px]">
      <ConferDetaiBanner />
      <ConferDetailHead />
      <RegisterNew />
    </div>
  );
}
